import React, { useState, useEffect } from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Typography from "@material-ui/core/Typography";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import ListItemText from "@material-ui/core/ListItemText";
import CircularProgress from "@material-ui/core/CircularProgress";

import { i18n } from "../../translate/i18n";
import useWhatsApps from "../../hooks/useWhatsApps";

// Componente separado para que o hook useWhatsApps (que busca as conexões na
// API) só rode quando o seletor realmente for exibido (isCellPhone = true).
const WhatsAppConnectionSelect = ({ value, onChange }) => {
	const { whatsApps, loading } = useWhatsApps();

	const connections = whatsApps.filter(
		(w) => !w.channel || w.channel === "whatsapp"
	);

	if (loading) {
		return (
			<div style={{ textAlign: "center", marginTop: 16 }}>
				<CircularProgress size={24} />
			</div>
		);
	}

	return (
		<Select
			fullWidth
			displayEmpty
			variant="outlined"
			value={value}
			onChange={(e) => onChange(e.target.value)}
			style={{ marginTop: 16 }}
			MenuProps={{
				anchorOrigin: {
					vertical: "bottom",
					horizontal: "left",
				},
				transformOrigin: {
					vertical: "top",
					horizontal: "left",
				},
				getContentAnchorEl: null,
			}}
			renderValue={() => {
				if (value === "") {
					return "Selecione uma Conexão";
				}
				const whatsapp = connections.find((w) => w.id === value);
				return whatsapp?.name;
			}}
		>
			{connections.map((whatsapp) => (
				<MenuItem dense key={whatsapp.id} value={whatsapp.id}>
					<ListItemText
						primary={
							<Typography component="span" style={{ fontSize: 14 }}>
								{whatsapp.name}{" "}
								<span
									style={{
										color:
											whatsapp.status === "CONNECTED" ? "green" : "red",
									}}
								>
									({whatsapp.status})
								</span>
							</Typography>
						}
					/>
				</MenuItem>
			))}
		</Select>
	);
};

const ConfirmationModal = ({
	title,
	children,
	open,
	onClose,
	onConfirm,
	isCellPhone,
	onSave,
}) => {
	const [selectedWhatsapp, setSelectedWhatsapp] = useState("");

	useEffect(() => {
		if (!open) setSelectedWhatsapp("");
	}, [open]);

	const handleSelectWhatsapp = (whatsappId) => {
		setSelectedWhatsapp(whatsappId);
		if (onSave) onSave(whatsappId);
	};

	return (
		<Dialog
			open={open}
			onClose={() => onClose(false)}
			aria-labelledby="confirm-dialog"
		>
			<DialogTitle id="confirm-dialog">{title}</DialogTitle>
			<DialogContent dividers>
				<Typography>{children}</Typography>
				{isCellPhone && open && (
					<WhatsAppConnectionSelect
						value={selectedWhatsapp}
						onChange={handleSelectWhatsapp}
					/>
				)}
			</DialogContent>
			<DialogActions>
				<Button
					variant="contained"
					onClick={() => onClose(false)}
					color="default"
				>
					{i18n.t("confirmationModal.buttons.cancel")}
				</Button>
				<Button
					variant="contained"
					disabled={Boolean(isCellPhone) && selectedWhatsapp === ""}
					onClick={() => {
						onClose(false);
						onConfirm();
					}}
					color="secondary"
				>
					{i18n.t("confirmationModal.buttons.confirm")}
				</Button>
			</DialogActions>
		</Dialog>
	);
};

export default ConfirmationModal;
